import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { StaticImage } from "gatsby-plugin-image";

const navLinks = [
  { name: "Businesses", path: "/businesses" },
  { name: "About", path: "/about-us" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "Contact", path: "/contact-us" },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#9b9b9b]/40 backdrop-blur-md py-4 shadow-lg" : "bg-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-6 flex justify-between md:justify-center items-center relative">
        {/* Desktop Nav Left */}
        <nav className="hidden md:flex space-x-8 md:mr-32">
          {navLinks.slice(0, 2).map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className="text-white hover:text-gray-300 transition-colors text-sm uppercase tracking-wide font-outfit font-bold"
              activeClassName="text-maroon-500"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <Link to="/" className="tracking-widest md:absolute md:left-1/2 md:-translate-x-1/2 -top-[22px]">
          <StaticImage src="../../images/logo.jpeg" alt="Logo" className="h-24 w-24"objectFit="contain"/>
        </Link>

        {/* Desktop Nav Right */}
        <nav className="hidden md:flex space-x-8 md:ml-32">
          {navLinks.slice(2).map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className="text-white hover:text-gray-300 transition-colors text-sm uppercase tracking-wide font-outfit font-bold"
              activeClassName="text-maroon-500"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Mobile Nav Button */}
        <button
          className="md:hidden text-white focus:outline-none ml-auto"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden absolute top-full left-0 w-full bg-black/95 backdrop-blur-md border-t border-gray-800"
          >
            <nav className="flex flex-col items-center py-8 space-y-6">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-xl text-gray-300 hover:text-maroon-500 font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
